import { useState, useEffect, useCallback, useMemo, useRef, MouseEvent, Fragment } from 'react';
import gsap from 'gsap';

interface ILiveKeywordProps {
    itemClickCallback: (keyword: string) => void;
}

interface IItemListProps {
    data: string[];
    index: number;
    itemClickCallback: ILiveKeywordProps['itemClickCallback'];
    setIsOpen: (isOpen: boolean) => void;
    rollingItemRefArr?: HTMLLIElement[];
}
interface IPopularKeyword {
    last_modify: string;
    pos: string;
    list: [string[]];
}


const ItemList = ({ data, index, itemClickCallback, setIsOpen, rollingItemRefArr }: IItemListProps) => {
    const liRef = useRef<HTMLLIElement>(null);
    const clickCallbak = useCallback((e: MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        itemClickCallback(data[0]);
        setIsOpen(false);
        return false;
    }, []);

    useEffect(() => {
        if(Array.isArray(rollingItemRefArr) && liRef?.current) {
            rollingItemRefArr.push(liRef?.current);
        }
    }, []);

    return <li className="hotkeyword-item" data-idx={index} ref={liRef}>
        <a href={`/search/index?query=${encodeURIComponent(data[0])}`} className="hotkeyword-item-link" onClick={clickCallbak}>
            <em className="hotkeyword-item-title">{data[0]}</em>
            <span className={`hotkeyword-item-rank is-${data[1]}`}>{ data[1] === 'same' ? '-' : data[2] }</span>
        </a>
    </li>;
};

const setLiveKeywordMotion = (arr: HTMLLIElement[], oldIndex?: number, newIndex?: number) => {
    if(!Array.isArray(arr) || arr?.length === 0) {
        return;
    }

    oldIndex = typeof oldIndex === 'number' ? oldIndex : -1;
    newIndex = typeof newIndex === 'number' ? newIndex : 0;

    if(oldIndex >= 0) {
        gsap.to(arr[oldIndex], {y:'-200%', duration: 1});
    } 

    gsap.fromTo(arr[newIndex], {y: '0%'}, {y: '-100%', duration: 1, onComplete: () => {
        oldIndex = newIndex;
        newIndex = arr?.length - 1 <= newIndex! ? 0 : newIndex! + 1;

        setTimeout(() => {
            setLiveKeywordMotion(arr, oldIndex, newIndex);
        }, 5000);
    }});
};

export const LiveKeyword = ({ itemClickCallback }: ILiveKeywordProps) => {
    let rollingItemRefArr: HTMLLIElement[] = [];
    const [isOpen, setIsOpen] = useState(false);
    const popularKeywordData: IPopularKeyword = window.popularKeyword?.data[0];
    const rollingItemlist = useMemo(() => popularKeywordData?.list?.map((v, i) => <ItemList {...{data: v, index: i, itemClickCallback, setIsOpen}} key={i} rollingItemRefArr={rollingItemRefArr}/>), []);
    const layerItemList = useMemo(() => popularKeywordData?.list?.map((v, i) => <ItemList {...{data: v, index: i, itemClickCallback, setIsOpen}} key={i}/>), []);
    const layerRef = useRef(null);
    const motionType = 'top';

    useEffect(() => {
        setLiveKeywordMotion(rollingItemRefArr);
    }, []);

    const clickBtnHotKeywordToggle = useCallback((e: MouseEvent<HTMLButtonElement>) => {
        const startObj = motionType ==='top' ? {y:'10%', opacity:0} : {y:'100%', opacity:1};

        setIsOpen(!isOpen);
        layerRef?.current && gsap.fromTo(layerRef?.current, startObj, {y:'0%', opacity:1, duration: 0.3, ease: "Power3.easeOut"});
    }, [isOpen]);

    return <Fragment>
        <div className={`hotkeyword ${isOpen ? 'is-active' : ''}`}>
            <span className="hotkeyword-title">실시간</span>
            <button className="hotkeyword-toggle" onClick={clickBtnHotKeywordToggle}>
                <svg xmlns="http://www.w3.org/2000/svg" className="svg" viewBox="0 0 13 7">
                    <path d="M6.194 6.806a.433.433 0 0 0 .612-.612L.74.127A.433.433 0 0 0 .127.74l6.067 6.066zm0-.612a.433.433 0 0 0 .612.612L12.873.74a.433.433 0 0 0-.613-.613L6.194 6.194z"></path>
                </svg>
            </button>
            <ol className="hotkeyword-list is-rolling">{rollingItemlist}</ol>
            <ol className="hotkeyword-list is-layer" ref={layerRef}>{layerItemList}</ol>
        </div>
    </Fragment>;
};
